import { KotlinLoggingConfiguration_getInstance1qkm2mkxywgav as KotlinLoggingConfiguration_getInstance } from '../../../../../kotlin-logging/io/github/oshai/kotlinlogging/KotlinLoggingConfiguration.mjs';
import {
  Level_INFO_getInstance2sl9dbxnkg9gp as Level_INFO_getInstance,
  Level_DEBUG_getInstance2jhazr5hebtey as Level_DEBUG_getInstance,
} from '../../../../../kotlin-logging/io/github/oshai/kotlinlogging/Level.mjs';
import { JsonFormatter_instance3dl7s47t3s4rb as JsonFormatter_instance } from './JsonFormatter.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function initializeLogging(developmentMode) {
  var tmp = KotlinLoggingConfiguration_getInstance().j2f_1;
  var tmp_0;
  if (developmentMode) {
    tmp_0 = Level_DEBUG_getInstance();
  } else {
    tmp_0 = Level_INFO_getInstance();
  }
  tmp.x2g(tmp_0);
  KotlinLoggingConfiguration_getInstance().j2f_1.y2g(JsonFormatter_instance);
}
//region block: exports
export {
  initializeLogging as initializeLogging2wy35dn799fjs,
};
//endregion

//# sourceMappingURL=InitializeLogging.mjs.map
